import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { PAGE_RANKING } from 'core/constants/endpoints'
import { countChildren, findApplicant, findSpouse } from '@hc-frontend/business'

function getRecEngine({
  location,
  members,
  healthcareUserId,
  healthcareSession,
  channel,
  sdate,
  sDate
}: GetRecEngineArgs) {
  const applicant = findApplicant(members)
  return fetchJSONHandleError({
    url: `${PAGE_RANKING}/rec_engine/v2/`,
    data: {
      state: location.state_acronym,
      gender: `${applicant.gender === 'f' ? 'fe' : ''}male`,
      age: applicant.age,
      spouse: findSpouse(members) ? 1 : 0,
      children: countChildren(members),
      user_id: healthcareUserId,
      session_id: healthcareSession,
      channel: channel.channelName,
      effective_date: sdate || sDate
    }
  })
}

export default getRecEngine
